<template>
  <div id="home">
    <el-row style="height: 100%">
      <el-col :span="12" class="content-left">
        <div class="content-box">
          <el-row type="flex" justify="center">
            <el-col :span="15">
              <h3>东营人力</h3>
              <div class="change">
                <div
                  class="psd"
                  :class="[index == 1 ? 'active' : '']"
                  @click="changeType(1)"
                >
                  密码登录
                </div>
                <div
                  class="codes"
                  :class="[index == 2 ? 'active' : '']"
                  @click="changeType(2)"
                >
                  短信登录
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="phone">
                    <el-input
                      placeholder="请输入手机号"
                      prefix-icon="el-icon-phone"
                      v-model="phone"
                      class="input"
                    >
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row v-if="index == 1" style="margin-top: 50px">
                <el-col :span="24">
                  <div class="phone">
                    <el-input
                      placeholder="请输入密码"
                      prefix-icon="el-icon-lock"
                      v-model="code"
                      class="input"
                      show-password
                    >
                    </el-input>
                  </div>
                </el-col>
              </el-row>

              <div class="code" v-if="index == 2">
                <el-row>
                  <el-col :span="15">
                    <el-input
                      placeholder="请输入验证码"
                      prefix-icon="el-icon-key"
                      v-model="code"
                      class="input"
                    >
                    </el-input>
                  </el-col>
                  <el-col :span="7" style="margin-left: 8%">
                    <span ref="code" class="get-code" @click="getCode"
                      >发送验证码</span
                    >
                  </el-col>
                </el-row>
              </div>

              <el-row style="margin-top: 100px">
                <el-col class="login" :span="24">
                  <span class="login-btn" @click="login">登录</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12" class="content-right"> </el-col>
    </el-row>
  </div>
</template>
<script>
import { countDwon, alertBox } from "@/utils/methods.js";
export default {
  data() {
    return {
      phone: "", // 手机号码
      code: "", //
      count: 60, // 倒计时数值
      index: 1,
    };
  },
  methods: {
    changeType(num) {
      this.index = num;
    },
    login() {
      this.axiosPost("/login", {
        userName: this.phone,
        password: this.code,
      }).then((res) => {
        //  console.log(res)
        let status, message;
        // let status = res.message=='success' ? 'success':'error'

        // console.log('mmmmmk')
        // console.log(res)
        if (res.message == "success") {
          status = "success";
          message = "登录成功";
          // console.log(res)

          sessionStorage.setItem("token", res.data.token);

          sessionStorage.setItem("userInfo", JSON.stringify(res.data));

          //  console.log('管理员数据')
          // console.log(res)
          // console.log('管理员数据')
          // console.log(res.data)
          // console.log('logo')
          // console.log(this.$store.state.userImg)
          this.$store.commit("updateUserImg", res.data.logo);
          // console.log('管理员头像')
          // console.log(res.data.logo)
          // console.log(this.$store.state.userImg)
          // this.$router.push({name:'occupationNav',params:{userInfo:res.data}})
          this.$router.replace({
            name: "company",
            params: { userInfo: res.data },
          });
          document.documentElement.onkeydown = null;
        } else {
          status = "error";
          message = res.message;
        }
        alertBox(this, message, status);
      });
    },
    getCode() {
      let code = this.$refs.code;

      // console.log(this.$refs.code)

      if (code.innerHTML == "发送验证码") {
        // console.log('11')
        this.axiosPost("/sendMessages/login", { userName: this.phone }).then(
          (res) => {
            // countDwon(code,this.count)
            if (res.message == "验证码已发送至手机") {
              // console.log('111')
              countDwon(code, this.count);
            }
            // console.log(res)
            let status =
              res.data || res.message == "验证码已发送至手机"
                ? "success"
                : "error";
            // let message = res.message
            alertBox(this, res.message, status);
          }
        );
      }
    },
  },
  mounted() {
    let that = this;
    document.documentElement.onkeydown = function () {
      if (event.keyCode == 13) {
        that.login();
      }
    };
  },
};
</script>
<style lang="less" scoped>
#home {
  height: 100%;
  // background-color:yellowgreen;
  background-color: white;
}
// left
.content-left {
  // background-color:red;
  height: 100%;
  position: relative;

  > .content-box {
    width: 100%;
    position: absolute;
    // background-color:yellow;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h3 {
      font-family: "Microsoft YaHei";
      font-weight: bold;
      color: #333333;
      line-height: 180px;
      font-size: 50px;
    }
    .change {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      //   background-color: pink;
      .psd {
        width: 120px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        // background-color: #fff;
      }
      .codes {
        width: 120px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        border: 1px solid #ccc;
        cursor: pointer;
        // background-color: #fff;
      }
    }
    .active {
      border: 1px solid #217dff !important;
      color: #217dff;
    }
    // phone
    .phone {
      height: 78px;
      .input {
        width: 100%;
        height: 100%;
        line-height: 78px;
      }
    }

    // code
    .code {
      width: 100%;
      margin-top: 50px;
      .input {
        height: 78px;
        width: 100%;
        line-height: 78px;
        display: inline-block;
      }
      .get-code {
        width: 100%;
        color: #666666;
        display: inline-block;
        height: 78px;
        background: #ffffff;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        line-height: 78px;
        text-align: center;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
}

.login .login-btn {
  display: inline-block;
  width: 100%;
  height: 78px;
  font-size: 30px;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #ffffff;
  line-height: 78px;
  text-align: center;
  background: #0a0a64;
  border-radius: 8px;
  cursor: pointer;
}

.content-right {
  height: 100%;
  background: url("../../assets/login.png") no-repeat;
  background-size: cover;
}
.icon {
  font-size: 30px;
  color: #dcdcdc;
  line-height: 78px;
}
</style>
